import React from "react";
import ReactDOM from 'react-dom/client'
import "./index.css";
import App from "./App";
import './i18n'; 
import { consumeUnedReturn } from "./utils/unedAuth.js";

// Antes de montar React: si venimos del SSO de la UNED, traduce el retorno a la
// ubicación que espera el router para que su primer render ya sea el correcto.
consumeUnedReturn();

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
